<div class="customer-dialog">
  <div class="customer-dialog__header">
    <span class="customer-dialog__title">
      @if (customerSubscription) {
        {{ 'updateCustomerSubscription' | translate }}
      } @else {
        {{ 'createCustomerSubscription' | translate }}
      }
    </span>
    <button
      type="button"
      mat-icon-button
      class="customer-dialog__close"
      (click)="onCancel()"
      [disabled]="isCreatingOrUpdatingCustomerSubscription">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="customer-dialog__body">
    <form
      [formGroup]="customerSubscriptionForm"
      class="customer-subscription-form"
    >
      <div class="customer-subscription-form__field">
        <label class="customer-subscription-form__label">Subscription Name*</label>
        <mat-form-field
          appearance="outline"
          class="customer-subscription-form__control"
          [class.spinner]="isLoadingCustomerSubscriptions"
        >
          <mat-select formControlName="name" placeholder="Select subscription">
            @for(subscription of customerSubscriptions; track
            subscription.SubscriptionId; let index = $index) {
            <mat-option [value]="subscription">{{
              subscription.SubscriptionName
            }}</mat-option>
            }
          </mat-select>
          <mat-error>{{ Messages.MSG_ERROR_REQUIRED }}</mat-error>
        </mat-form-field>
      </div>

      <div class="customer-subscription-form__field">
        <label class="customer-subscription-form__label">Start Date*</label>
        <mat-form-field appearance="outline" class="customer-subscription-form__control">
          <input
            matInput
            [matDatepicker]="startDatePicker"
            formControlName="startDate"
            placeholder="Select start date"
            [max]="customerSubscriptionForm.get('endDate')?.value"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="startDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
          <mat-error>{{ Messages.MSG_ERROR_REQUIRED }}</mat-error>
        </mat-form-field>
      </div>

      <div class="customer-subscription-form__field">
        <label class="customer-subscription-form__label">End Date*</label>
        <mat-form-field appearance="outline" class="customer-subscription-form__control">
          <input
            matInput
            [matDatepicker]="endDatePicker"
            formControlName="endDate"
            placeholder="Select end date"
            [min]="customerSubscriptionForm.get('startDate')?.value"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="endDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
          <mat-error>{{ Messages.MSG_ERROR_REQUIRED }}</mat-error>
        </mat-form-field>
      </div>

      <div class="customer-subscription-form__toggle">
        <mat-slide-toggle formControlName="isActive" labelPosition="before">
          {{ 'active' | translate }}
        </mat-slide-toggle>
      </div>
    </form>
  </div>

  <div class="customer-dialog__actions">
    <button
      type="button"
      class="customer-dialog__cancel-btn"
      (click)="onCancel()"
      [disabled]="isCreatingOrUpdatingCustomerSubscription">
      {{ 'cancel' | translate }}
    </button>
    <button
      type="button"
      class="customer-dialog__submit-btn"
      (click)="createOrUpdateCustomerSubscription()"
      [class.spinner]="isCreatingOrUpdatingCustomerSubscription"
      [disabled]="isCreatingOrUpdatingCustomerSubscription || isLoadingCustomerSubscriptions">
      @if (customerSubscription) {
        {{ 'saveChanges' | translate }}
      } @else {
        {{ 'createCustomerSubscription' | translate }}
      }
    </button>
  </div>
</div>
